export  const naturalUserLevels = [0, 10, 11, 12, 13, 14]
export  const legalUserLevels = [17, 18]
export const coinkUserLevels = [100, 101]
